import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isNonPrivateCloud } from 'bootstrap/lib/isNonPrivateCloud';
import { loadInitialOpxTheme, loadInitialTheme, ThemeMode } from 'mini-theme';

/**
 * Load the initial theme based on the user config
 * For an OPX flow, get the palette from the host and initialize the theme
 * @param sessionDataPromise
 */
export const initializeTheme = async (): Promise<void> => {
    const isPrivateCloud = !isNonPrivateCloud();
    if (isPrivateCloud) {
        loadInitialTheme(ThemeMode.Light);
        return;
    }

    if (isHostAppFeatureEnabled('opxComponentLifecycle')) {
        return loadInitialOpxTheme();
    }

    /**
     * MiniDarkMode key to be updated in UserOptionsType in owa-service.
     * Fallback to user's system theme if user config is missing theme mode
     */
    const themeMode =
        (getUserConfiguration()?.UserOptions as any)?.MiniDarkMode ?? ThemeMode.System;
    loadInitialTheme(themeMode);
};
